import React from 'react'

const ControlRoomIcon = (): JSX.Element => {
  return (
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_8797_575" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
<rect x="0.5" width="24" height="24" fill="#999B9F"/>
</mask>
<g mask="url(#mask0_8797_575)">
<path d="M15.5962 19.5V13.0963H22V19.5H15.5962ZM11.5963 10.9038V4.5H22V10.9038H11.5963ZM3 19.5V13.0963H13.4038V19.5H3ZM3 10.9038V4.5H9.40375V10.9038H3ZM13.096 9.404H20.5V6H13.096V9.404ZM4.5 18H11.904V14.596H4.5V18ZM17.096 18H20.5V14.596H17.096V18ZM4.5 9.404H7.904V6H4.5V9.404Z" fill="#999B9F"/>
</g>
</svg>

  )
}

export default ControlRoomIcon